import { DatoCmsSportManifestazionePage } from 'lib/datoCms/types';

export const extractLabel = (page: DatoCmsSportManifestazionePage): LabelsBoxWithSearchType => {
  return {
    title: page?.title!,
    searchTitle: page?.searchTitle,
    labelScommesseFound: page?.labelScommesseFound,
    searchPlaceholder: page?.pleaceholderSearchTitle,
  };
};
export type LabelsBoxWithSearchType = {
  title: string;
  searchTitle: string;
  labelScommesseFound: string;
  searchPlaceholder: string;
};
